import React, { memo } from 'react'
import moment from 'moment'
import { datetimeFormatter } from 'transfix-ui/components/FormattedDateTime'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { IAttachedDocument } from 'types/graphqlTypes'
import { CheckFilledIcon } from 'transfix-icons'
import { AllowedTimezones } from 'constants/AllowedTimezones'

interface ILaneAgreementTagProps {
  laneAgreement: Pick<IAttachedDocument, 'createdAt'>
}

const LaneAgreementTag = memo<ILaneAgreementTagProps>(({ laneAgreement: { createdAt } }) => {
  const formattedDate = datetimeFormatter({
    datetime: createdAt,
    displayTimezone: moment.tz.guess() as AllowedTimezones,
    format: 'dateAndYearFullDateAlways',
    showTimezone: false,
    abbreviated: true,
  })

  return (
    <Tooltip position='bottom' trigger={<CheckFilledIcon color='green3' size='xlarge' />}>
      Lane agreement uploaded {formattedDate}
    </Tooltip>
  )
})

export default LaneAgreementTag
